export default {
  getCustomColumns: state => state.customColumns.reduce((acc, column) => {
    acc[column.slug] = column
    return acc
  }, {})
};